import { render } from "./ListNoOwn.vue?vue&type=template&id=8f9eec02"
import script from "./ListNoOwn.vue?vue&type=script&lang=js"
export * from "./ListNoOwn.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__